declare namespace $ {

	type $shm_textarea_code_view__attr_shm_textarea_code_1 = $mol_type_enforce<
		({ 
			'inert': string,
		})  & ReturnType< $shm_textarea_code_view['attr'] >
		,
		ReturnType< $shm_textarea_code_view['attr'] >
	>
	type $shm_textarea_code_view__text_shm_textarea_code_2 = $mol_type_enforce<
		ReturnType< $shm_textarea_code['value'] >
		,
		ReturnType< $shm_textarea_code_view['text'] >
	>
	type $shm_textarea_code_view__row_numb_shm_textarea_code_3 = $mol_type_enforce<
		ReturnType< $shm_textarea_code['row_numb'] >
		,
		ReturnType< $shm_textarea_code_view['row_numb'] >
	>
	type $shm_textarea_code_view__sidebar_showed_shm_textarea_code_4 = $mol_type_enforce<
		ReturnType< $shm_textarea_code['sidebar_showed'] >
		,
		ReturnType< $shm_textarea_code_view['sidebar_showed'] >
	>
	type $shm_textarea_code_view__highlight_shm_textarea_code_5 = $mol_type_enforce<
		ReturnType< $shm_textarea_code['highlight'] >
		,
		ReturnType< $shm_textarea_code_view['highlight'] >
	>
	type $shm_textarea_code_view__syntax_shm_textarea_code_6 = $mol_type_enforce<
		ReturnType< $shm_textarea_code['syntax'] >
		,
		ReturnType< $shm_textarea_code_view['syntax'] >
	>
	export class $shm_textarea_code extends $mol_textarea {
		spellcheck( ): boolean
		View( ): $shm_textarea_code_view
	}
	
}

//# sourceMappingURL=code.view.tree.d.ts.map